export var sanitizeForDiff = function(html) {
    return html.replaceAll("&ldquo;", "\u201C").replaceAll("&rdquo;", "\u201D").replaceAll("&rsquo;", "\u2019").replaceAll("&bull;", "\u2022").replaceAll("&ndash;", "\u2013");
};
